export default function (key, custom) {
  const multiple = `/${key}`;
  const single = `${multiple}/:id`;

  return {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
    ...custom,
  };
}
